import React from 'react';
import { motion } from 'framer-motion';
import { TOPIC_CLUSTERS, RECOMMENDATIONS, ALERTS } from '../../data/mockData';
import { useKPIs } from '../../context/KPIContext';
import { KPICard } from '../../components/ui/KPICard';
import { HotTopicItem } from '../../components/ui/HotTopicItem';
import { AlertCard } from '../../components/ui/AlertCard';
import { Plus, Flame, Settings2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function HRDashboard() {
  const navigate = useNavigate();
  const {
    kpis
  } = useKPIs();
  // Sort topics by mention count descending
  const sortedTopics = [...TOPIC_CLUSTERS].sort((a, b) => b.mentionCount - a.mentionCount);
  return <div className="space-y-8 pb-20" data-id="element-194">
      <header className="flex justify-between items-end" data-id="element-195">
        <div data-id="element-196">
          <h1 className="text-3xl font-bold text-white mb-2" data-id="element-197">HR Overview</h1>
          <p className="text-secondary" data-id="element-198">
            Real-time organizational pulse and insights.
          </p>
        </div>
        <button onClick={() => navigate('/hr/forms/builder')} className="flex items-center space-x-2 bg-accent text-background px-4 py-2 rounded-lg font-medium hover:bg-accentHover transition-colors shadow-lg shadow-accent/10" data-id="element-199">
          <Plus className="w-4 h-4" data-id="element-200" />
          <span data-id="element-201">Create Feedback Form</span>
        </button>
      </header>

      {/* Alerts Section */}
      {ALERTS.length > 0 && <section data-id="element-202">
          {ALERTS.map(alert => <AlertCard key={alert.id} alert={alert} data-id="element-203" />)}
        </section>}

      {/* Unified Hot Topics Section */}
      <section className="glass-panel p-6 rounded-xl" data-id="element-204">
        <div className="mb-6 flex items-center space-x-3" data-id="element-205">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-accent/10 text-accent" data-id="element-206">
            <Flame className="h-5 w-5" data-id="element-207" />
          </div>
          <div data-id="element-208">
            <h2 className="text-lg font-semibold text-white" data-id="element-209">Hot Topics</h2>
            <p className="text-xs text-secondary" data-id="element-210">
              AI-detected patterns with recommendations
            </p>
          </div>
        </div>

        <div className="space-y-1" data-id="element-211">
          {sortedTopics.map((topic, idx) => {
          const kpiBucket = kpis.find(k => k.id === topic.kpiBucketId);
          const recommendation = RECOMMENDATIONS.find(r => r.relatedTopicId === topic.id);
          return <HotTopicItem key={topic.id} topic={topic} index={idx} kpiBucketName={kpiBucket?.name || 'Unknown KPI'} recommendation={recommendation} data-id="element-212" />;
        })}
        </div>
      </section>

      {/* KPI Overview */}
      <section data-id="element-213">
        <div className="flex items-center justify-between mb-6" data-id="element-214">
          <h2 className="text-xl font-semibold text-white" data-id="element-215">KPI Buckets</h2>
          <button onClick={() => navigate('/hr/kpi/builder')} className="flex items-center space-x-1 text-xs font-medium text-accent hover:text-white transition-colors" data-id="element-216">
            <Settings2 className="w-3 h-3" data-id="element-217" />
            <span data-id="element-218">Manage KPIs</span>
          </button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-219">
          {kpis.map((kpi, idx) => <motion.div key={kpi.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: idx * 0.05
        }} data-id="element-220">
              <KPICard kpi={kpi} role="hr" data-id="element-221" />
            </motion.div>)}
        </div>
      </section>
    </div>;
}